import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import Lenis from '@studio-freight/lenis';
import './App.css';
import Navbar from './components/Navbar/Navbar';
import Home from './components/Home/Home';
import FullAbout from './components/FullAbout/FullAbout';
import FullServices from './components/FullServices/FullServices';
import CncMachining from './components/CncMachining/CncMachining';
import VmcMachining from './components/VmcMachining/VmcMachining';
import DrillingOperations from './components/DrillingOperations/DrillingOperations';
import MillingServices from './components/MillingServices/MillingServices';
import MetalCutting from './components/MetalCutting/MetalCutting';
import Footer from './components/Footer/Footer';
import ScrollToTop from './components/ScrollToTop';
import Contact from './components/Contact/Contact';
import Products from './components/Products/Products';
import FloatingActions from './components/FloatingActions/FloatingActions';


const AppContent = () => {
  const location = useLocation();

  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), 
      direction: 'vertical',
      gestureDirection: 'vertical',
      smooth: true,
      mouseMultiplier: 1,
      smoothTouch: false,
      touchMultiplier: 2,
      infinite: false,
    });

    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);

    return () => {
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App">
      <ScrollToTop />
      <Navbar />
      <div key={location.pathname} className="page-transition">
        <Routes location={location}>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<FullAbout />} />
          <Route path="/services" element={<FullServices />} />
          <Route path="/services/cnc-machining" element={<CncMachining />} />
          <Route path="/services/vmc-machining" element={<VmcMachining />} />
          <Route path="/services/drilling-operations" element={<DrillingOperations />} />
          <Route path="/services/milling-services" element={<MillingServices />} />
          <Route path="/services/metal-cutting" element={<MetalCutting />} />
          <Route path="/products" element={<Products />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </div>
      <Footer />
      <FloatingActions />
    </div>

  );
};

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
